import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import ToTopBtnStore from './store';

const ToTopBtn = ({ store, className }) => {
  store.use();

  return <div className={cx(styles.toTopBtn, className)} onClick={store.scrollToTop} />;
};

export default wrapStore(ToTopBtn, ToTopBtnStore);
